import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: 'input,[required]'
})
export class AddAsteriscoDirective implements AfterViewInit {

  constructor(
    private renderer: Renderer2,
    private el: ElementRef
    ) {}

  ngAfterViewInit(): void {
    this.run();
  }

  private run(): void {
    try {
      const parent = this.renderer.parentNode(this.el.nativeElement);

      const achouAtributoRequired = this.procurarAtributoRequired(parent);
      if ( achouAtributoRequired ) {
        this.adicionarAsterisco(parent);
      }
    }
    catch (e) {
      console.error('add-asterisco.directive.ts', e.message);
    }
  }

  adicionarAsterisco(parent: any): void {
    try {
      // if (parent.getElementsByTagName('LABEL').length && !parent.getElementsByClassName('required-asterisk').length) {
      //   parent.getElementsByTagName('LABEL')[0].innerHTML += '<span class="asterisco">*</span>';
      // }
      if ( parent.getElementsByTagName('LABEL') && parent.getElementsByTagName('LABEL')[0] ) {
        parent.getElementsByTagName('LABEL')[0].innerHTML += '<span class="asterisco">*</span>';
      }
    }
    catch (e) {
      console.error('add-asterisco.directive', 'Asterisco de obrigatoriedade não colocado.');
    }
  }

  procurarAtributoRequired(parent: any): boolean {
    try {
      let achou = this.procurarAtributoRequiredImpl(parent);
      if ( achou ) {
        return true;
      }

      const children = parent.children;
      if ( children && children.length > 0 ) {

        for ( const o of children ) {
          achou = this.procurarAtributoRequiredImpl(o);
          if ( achou ) {
            return true;
          }
        }
      }
    }
    catch (e) {
      return false;
    }

    return false;
  }

  procurarAtributoRequiredImpl(parent: any): boolean {
    try {
      const attrs = parent.attributes;
      if ( attrs ) {
        const required = attrs['required'];
        if ( required ) {
          return true;
        }

        const ngReflectRequired = attrs['ng-reflect-required'];
        if ( ngReflectRequired ) {
          return ngReflectRequired.value === 'true';
        }
      }
    }
    catch (e) {
      return false;
    }

    return false;
  }

}
